import { NetworkService } from "./NetworkService";

export class ReportsServices {

  static async downloadReport(indicatorId) {
    await NetworkService.requestDownload({
      url: `indicators/target?id=${indicatorId}`,
    }).catch((error) => {
      console.log(error);
    });
  }


}

